<div class="row global-notifications" [ngClass]="notificationType">
  <bp-icon class="global-notifications-icon" [icon]="options.messageClass" size="24" theme="regular"></bp-icon>
  <div class="col-9">
    <div class="global-notifications-title">
      {{ title }}
    </div>
    <div class="global-notifications-message">
      {{ message }}
    </div>
    @if (action) {
      <div class="global-notifications-action" (click)="onActionClick($event)">
        {{ actionMessage | translate }}
      </div>
    }
  </div>
  @if (closeButton) {
    <bp-icon
      (click)="onCloseClick()"
      class="global-notifications-close-icon"
      icon="dismiss"
      size="24"
      theme="regular">
    </bp-icon>
  }
</div>
